<template>
	<v-form ref="userForm">
		<v-row>
			<v-col cols="12" :sm="fenlan">
				<v-text-field label="账号" :disabled="model != 'reg' && model != 'superadmin-add'" prepend-icon="mdi-account" type="text" clearable v-model="userInfo.Username" :rules="[...rules.username]" validate-on-blur :error-messages="errors_username"> </v-text-field>
				<v-text-field :label="model != 'reg' && model != 'superadmin-add' ? '默认不改密码' : '密码'" prepend-icon="mdi-lock" :type="showpassword ? 'text' : 'password'" :append-icon="showpassword ? 'mdi-eye-off' : 'mdi-eye'" @click:append="showpassword = !showpassword" clearable v-model="password" :rules="rules.password" validate-on-blur></v-text-field>
				<v-text-field v-show="!!password" label="确认密码" prepend-icon="mdi-lock" :type="showpassword ? 'text' : 'password'" :append-icon="showpassword ? 'mdi-eye-off' : 'mdi-eye'" @click:append="showpassword = !showpassword" clearable v-model="configpass" :rules="rules.configpassword" validate-on-blur></v-text-field>
				<v-text-field :label="userInfo.Usersproer.Usertype == 0 ? '姓名' : '单位名称'" prepend-icon="mdi-rename-box" type="text" clearable v-model="userInfo.Usersproer.Name" :rules="[rules.required, ...rules.username]" validate-on-blur> </v-text-field>
				<!-- <v-text-field v-if="userInfo.Usersproer.Usertype==0" label="姓名" prepend-icon="mdi-rename-box" type="text"
          clearable v-model="userInfo.Usersproer.Zjname" :rules="[rules.required, ...rules.username]" validate-on-blur>
        </v-text-field>
        <v-text-field v-else label="单位名称" prepend-icon="mdi-rename-box" type="text"
          clearable v-model="userInfo.Usersproer.Name" :rules="[rules.required, ...rules.username]" validate-on-blur>
        </v-text-field> -->

				<v-switch v-if="model != 'myInfo' && model != 'reg'" color="success" label="用户状态" v-model="userInfo.Status"> </v-switch>
				<v-radio-group class="d-inline-block" v-model="userInfo.Usersproer.Usertype" row>
					<v-icon>mdi-account-settings</v-icon>
					<span class="mx-2">类型</span>
					<v-radio label="个人" :value="0"></v-radio>
					<v-radio label="企业" :value="1"></v-radio>
				</v-radio-group>
				<v-text-field :class="model != 'superadmin-edit' ? 'd-none' : ''" label="Openid" v-model="userInfo.Usersproer.Openid"> </v-text-field>
				<v-autocomplete v-if="model == 'superadmin-add' || model == 'superadmin-edit'" v-model="newroles" :items="roles" chips label="角色" item-text="RoleName" item-value="Id" multiple>
					<template v-slot:selection="data">
						<v-chip v-bind="data.attrs" :input-value="data.selected" close @click:close="removeroles(data.item)">
							{{ data.item.RoleName }}
						</v-chip>
					</template>
					<template v-slot:item="data">
						<template>
							<v-list-item-content>
								<v-list-item-title v-html="data.item.RoleName"></v-list-item-title>
							</v-list-item-content>
						</template>
					</template>
				</v-autocomplete>
				<v-btn class="float-right" text color="success" @click="typechange"> {{ fenlan == 12 ? '更多 more >>' : '精简 less <<' }}</v-btn>
			</v-col>
			<v-col v-show="fenlan == 6" cols="12" :sm="fenlan">
				<v-text-field label="电话" prepend-icon="mdi-phone" type="text" clearable v-model="userInfo.Usersproer.Phone" :rules="[rules.required, rules.phone]" validate-on-blur></v-text-field>
				<v-text-field label="生产地址" prepend-icon="mdi-map-marker" type="text" clearable v-model="userInfo.Usersproer.Addr" :rules="[rules.required, rules.maxlen]" validate-on-blur></v-text-field>
				<v-text-field label="Email" prepend-icon="mdi-email" type="text" clearable v-model="userInfo.Email" validate-on-blur :error-messages="errors_email"></v-text-field>
				<v-text-field v-show="userInfo.Usersproer.Usertype == 1" label="法人" prepend-icon="mdi-account-box" type="text" clearable v-model="userInfo.Usersproer.Faren" :rules="[rules.maxlen]" validate-on-blur></v-text-field>
				<v-text-field v-show="userInfo.Usersproer.Usertype != 0" label="统一信用代码" prepend-icon="mdi-pen" type="text" clearable v-model="userInfo.Usersproer.Code" :rules="[rules.maxlen]" validate-on-blur></v-text-field>
				<!-- <v-text-field v-else label="证件号" prepend-icon="mdi-pen" type="text"
          clearable v-model="userInfo.Usersproer.Zjnum" :rules="[rules.maxlen]" validate-on-blur></v-text-field> -->
				<v-file-input v-if="userInfo.Usersproer.Usertype == 1" accept="image/png, image/jpeg, image/gif" :rules="[rules.filesize]" show-size counter label="营业执照" v-model="filesyyzz" :loading="loading" @change="upimg(filesyyzz, 'Imgyyzz')">
					<template v-slot:append-outer>
						<v-img v-if="userInfo.Usersproer.Imgyyzz" max-width="45" max-height="45" :src="$store.state.serverhosts + userInfo.Usersproer.Imgyyzz" @click="viewImg(userInfo.Usersproer.Imgyyzz)">
							<v-icon color="error" @click.stop="delimg(userInfo.Usersproer.Imgyyzz, 'Imgyyzz')">mdi-close-circle </v-icon>
						</v-img>
					</template>
				</v-file-input>
				<!-- <v-file-input accept="image/png, image/jpeg, image/gif" :rules="[rules.filesize]" show-size counter
          :label="(userInfo.Usersproer.Usertype==0?'':'法人') + '身份证正面'" v-model="filessfz1" :loading="loading"
          @change="upimg(filessfz1,'Imgsfz1')">
          <template v-slot:append-outer>
            <v-img v-if="userInfo.Usersproer.Imgsfz1" max-width="45" max-height="45"
              :src="$store.state.serverhosts + userInfo.Usersproer.Imgsfz1"
              @click="viewImg(userInfo.Usersproer.Imgsfz1)">
              <v-icon color="error" @click.stop="delimg(userInfo.Usersproer.Imgsfz1,'Imgsfz1')">mdi-close-circle
              </v-icon>
            </v-img>
          </template>
        </v-file-input>
        <v-file-input accept="image/png, image/jpeg, image/gif" :rules="[rules.filesize]" show-size counter
          :label="(userInfo.Usersproer.Usertype==0?'':'法人') + '身份证背面'" v-model="filessfz2" :loading="loading"
          @change="upimg(filessfz2,'Imgsfz2')">
          <template v-slot:append-outer>
            <v-img v-if="userInfo.Usersproer.Imgsfz2" max-width="45" max-height="45"
              :src="$store.state.serverhosts + userInfo.Usersproer.Imgsfz2"
              @click="viewImg(userInfo.Usersproer.Imgsfz2)">
              <v-icon color="error" @click.stop="delimg(userInfo.Usersproer.Imgsfz2,'Imgsfz2')">mdi-close-circle
              </v-icon>
            </v-img>
          </template>
        </v-file-input> -->
				<v-btn v-if="model == 'myInfo' && userInfo.Face" :loading="loading" color="primary" @click="delface">取消人脸识别</v-btn>
				<v-dialog v-else v-model="dialog" :max-width="videoWidth">
					<template v-slot:activator="{ on, attrs }">
						<v-btn v-if="model == 'myInfo'" v-bind="attrs" v-on="on" :loading="loading" color="primary">人脸识别</v-btn>
					</template>
					<v-card>
						<v-card-title class="headline grey lighten-2"
							>人脸识别<v-spacer></v-spacer><span>{{ facetxt }}</span></v-card-title
						>
						<div ref="facebox" style="position: relative;">
							<video id="facevideo" ref="video" :width="faceWidth" :height="faceHeight" autoplay></video>
							<canvas ref="canvas" :width="faceWidth" :height="faceHeight" style="position: absolute;left: 0;top: 0;"></canvas>
						</div>
						<v-divider></v-divider>
						<!-- <v-card>
              <v-badge
                bordered
                overlap
                color="error"
                icon="mdi-close-circle"
                class="ma-2"
                v-for="(item,index) in imgarr" :key="index"
              >
                <v-avatar size="80" tile @click="delimgarr(index)">
                  <v-img :src="item"></v-img>
                </v-avatar>
              </v-badge>
            </v-card> -->
						<v-card-actions>
							<!-- <v-btn color="primary" text @click="faceup">上传</v-btn> -->
							<v-spacer></v-spacer>
							<v-btn color="primary" text @click="dialog = false">取消</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>
				<v-btn text color="error" class="float-right" v-if="sysType" plain>{{ userInfo && userInfo.Usersproer && userInfo.Usersproer.Zjnum && userInfo.Usersproer.Zjnum.length > 0 ? '证件信息已保存' : '请放置身份证件' }}</v-btn>
			</v-col>
		</v-row>
		<v-card-actions>
			<v-btn v-if="model.indexOf('admin') == -1" dark color="orange darken-2" @click="$router.go(-1)">返回 </v-btn>
			<v-btn v-else dark color="orange darken-2" @click="submit(false)">关闭</v-btn>
			<v-spacer></v-spacer>
			<v-btn :loading="loading" color="success" @click="submit(true)">提交</v-btn>
		</v-card-actions>
	</v-form>
</template>

<script>
import axios from 'axios';
require('@/plugins/tracking/tracking-min.js');
require('@/plugins/tracking/data/face.js');
export default {
	name: 'userForm',
	props: {
		model: {
			type: String,
			default: '',
		},
		userData: {
			type: Object,
			default: {},
		},
	},
	data: function() {
		return {
			faceaddnum: 0,
			faceWidth: 640,
			faceHeight: 480,
			videoWidth: 640,
			videoHeight: 480,
			timerreadcard: null,
			sysType: false,
			oldrect: { x: 0, y: 0, width: 0, height: 0 },
			// imgarr: [],
			facetxt: '正在启动摄像头...',
			dialog: false,
			tracker: null,
			fenlan: this.model == 'myInfo' || this.model == 'reg' ? 6 : 12,
			errors_username: [],
			errors_email: [],
			password: null,
			configpass: null,
			filesyyzz: [],
			// filessfz1: [],
			// filessfz2: [],
			showpassword: false,
			loading: false,
			userInfo: {},
			roles: [],
			newroles: [],
			oldroles: [],
			rules: {
				required: (value) => !!value || '必填项',
				maxlen: (value) => value === null || value.length <= 20 || '长度小于20',
				username: [(value) => {
					if (!value) return '必填项';
					if (!(value.length >= 2 && value.length <= 20)) return '长度2-20';
					if (!/^[\u4e00-\u9fa5_a-zA-Z0-9]+$/.test(value)) return '字符范围(汉字、_、a-z、A-Z、0-9)';
					if (this.userData.Username != value) {
						this.$api.isHasUser({ Username: value }).then((res) => {
							if (res.data) {
								this.errors_username = ['用户已经存在'];
							}
						});
					}
					this.errors_username = [];
					return true;
				}],
				password: [(value) => !!value || (this.model != 'reg' && this.model != 'superadmin-add') || '必填项', (value) => value === null || (value.length >= 6 && value.length <= 20) || '长度6-20'],
				configpassword: [(value) => value == this.password || (this.password === null && value === '') || (value === null && this.password === '') || '密码不一致'],
				filesize: (value, item) => typeof value === 'undefined' || value.length == 0 || value.size < 2000000 || '不能大于2MB!',
				email: (value) => {
					if (!value) return '必填项';
					if (!(value.length >= 2 && value.length <= 40)) return '长度2-40';
					if (!/^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/.test(value)) return 'Email格式不正确';
					if (this.userData.Email != value) {
						this.$api.isHasUser({ Email: value }).then((res) => {
							if (res.data) {
								this.errors_email = ['Email已经存在'];
							}
						});
					}
					this.errors_email = [];
					return true;
				},
				phone: (value) => value === null || /^[0-9\-\+]{10,18}$/.test(value) || '电话格式不正确',
			},
		};
	},
	watch: {
		userData(value) {
			this.initdata();
		},
		dialog(val) {
			this.faceaddnum = 0;
			if (val) {
				// H5调用电脑摄像头API
				navigator.mediaDevices
					.getUserMedia({ video: true })
					.then((success) => {
						// 摄像头开启成功
						this.$refs['video'].srcObject = success;
						// 实时拍照效果
						this.$refs['video'].play();
						setTimeout(() => {
							this.initvideo();
						}, 500);
					})
					.catch((error) => {
						this.$store.commit('setsnack', { message: '摄像头开启失败，请检查摄像头是否可用！' });
						console.error('摄像头开启失败，请检查摄像头是否可用！');
						this.facetxt = '摄像头初始化失败';
					});
			} else {
				this.tracker && this.tracker.removeListener('track', this.handleTracked) && tracking.track('#facevideo', this.tracker, { camera: false });
				let canvas = this.$refs['canvas'];
				canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height);
				this.faceWidth = 640;
				this.faceHeight = 480;
				if (!this.$refs['video'].srcObject) {
					return;
				}
				let stream = this.$refs['video'].srcObject;
				let tracks = stream.getTracks();
				tracks.forEach((track) => {
					track.stop();
				});
				this.$refs['video'].srcObject = null;
			}
		},
	},
	created() {
		this.initdata();
		if (this.model == 'superadmin-add' || this.model == 'superadmin-edit') {
			this.loading = true;
			this.$api
				.getRoles({
					limit: -1,
					fields: 'Id,RoleName',
				})
				.then((res) => {
					this.loading = false;
					if (res.data) {
						this.roles = res.data;
					}
				})
				.catch((error) => {
					this.loading = false;
					console.error(error);
					this.$store.commit('setsnack', {
						message: '获取角色列表失败！',
					});
				});
		}
		let _this = this;
		this.timerreadcard = setInterval(() => {
			_this.openCardDiver();
		}, 1000);
	},
	beforeDestroy() {
		clearInterval(this.timerreadcard);
	},
	methods: {
		initvideo(num = 0) {
			if (this.$refs.video.videoWidth > 0) {
				this.videoWidth = this.$refs.video.videoWidth;
				this.videoHeight = this.$refs.video.videoHeight;
				this.faceWidth = this.$refs.facebox.offsetWidth;
				this.faceHeight = parseInt(this.faceWidth * (this.videoHeight / this.videoWidth));

				this.facetxt = '';
				setTimeout(() => {
					this.tracker = new tracking.ObjectTracker('face');
					this.tracker.setInitialScale(4);
					this.tracker.setStepSize(2);
					this.tracker.setEdgesDensity(0.1);
					tracking.track('#facevideo', this.tracker);
					this.startvideo();
				}, 1000);
			} else {
				console.log('摄像头初始化失败：', num);
				num++;
				if (num < 10) {
					setTimeout(() => {
						this.initvideo(num);
					}, 500);
				}
			}
		},
		openCardDiver() {
			if (this.loading) {
				return;
			}
			axios
				.get('http://127.0.0.1:19196/opendevice')
				.then((res) => {
					//这里并不会成功，为什么呢？？先不管了！
					if (res.resultFlag == 0) {
						this.toReadCard();
					}
				})
				.catch((res) => {
					if (res.resultFlag == 0) {
						//这里是成功的结果
						this.toReadCard();
					} else {
						if (res.resultFlag != 0) {
							console.log('打开读卡器失败');
							clearInterval(this.timerreadcard);
						}
					}
				});
		},
		toReadCard() {
			this.sysType = true;
			if (this.loading) {
				return;
			}
			axios
				.get('http://127.0.0.1:19196/readcard')
				.then((res) => {
					if (res.resultFlag == 0) {
						this.toCardSet(res);
					}
				})
				.catch((res) => {
					if (res.resultFlag == 0) {
						this.toCardSet(res);
					} else {
						if (res.errorMsg != '读卡失败') {
							console.log('未检测到证件读卡器');
							clearInterval(this.timerreadcard);
						}
					}
				});
		},
		toCardSet(res) {
			console.log('Card-Data:', res);
			this.userInfo.Usersproer.Zjnum = res.certNumber;
			this.userInfo.Usersproer.Zjaddr = res.certAddress;
			this.userInfo.Usersproer.Zjorg = res.certOrg;
			this.userInfo.Usersproer.Zjtype = res.certType;
			if (res.effDate.length == 8) {
				this.userInfo.Usersproer.Zjtimestart = res.effDate.substr(0, 4) + '-' + res.effDate.substr(4, 2) + '-' + res.effDate.substr(-2);
			} else if (res.effDate.length == 10) {
				this.userInfo.Usersproer.Zjtimestart = res.effDate.substr(0, 4) + '-' + res.effDate.substr(5, 2) + '-' + res.effDate.substr(-2);
			}
			if (res.expDate.length == 8) {
				this.userInfo.Usersproer.Zjtimeend = res.expDate.substr(0, 4) + '-' + res.expDate.substr(4, 2) + '-' + res.expDate.substr(-2);
			} else if (res.expDate.length == 10) {
				this.userInfo.Usersproer.Zjtimeend = res.expDate.substr(0, 4) + '-' + res.expDate.substr(5, 2) + '-' + res.expDate.substr(-2);
			}
			this.userInfo.Usersproer.Zjgender = res.gender;
			this.userInfo.Usersproer.Zjpic = res.identityPic;
			this.userInfo.Usersproer.Zjnation = res.nation;
			this.userInfo.Usersproer.Zjname = res.partyName;
			console.log('Usersproer:', this.userInfo.Usersproer);
			clearInterval(this.timerreadcard);
			if (this.model == 'reg') {
				this.showpassword = true;
				if (!this.userInfo.Username) {
					this.userInfo.Username = res.partyName;
				}
				if (!this.password) {
					this.password = '123456';
				}
				if (!this.configpass) {
					this.configpass = '123456';
				}
			}
			if (!this.userInfo.Usersproer.Name) {
				this.userInfo.Usersproer.Name = res.partyName;
			}
			if (!this.userInfo.Usersproer.Faren || this.userInfo.Usersproer.Faren.length < 2) {
				this.userInfo.Usersproer.Faren = res.partyName;
			}
			if (!this.userInfo.Usersproer.Addr) {
				this.userInfo.Usersproer.Addr = res.certAddress.length > 20 ? res.certAddress.substr(0, 20) : res.certAddress;
			}
		},
		delface() {
			//取消人脸识别
			if (this.loading) {
				return;
			}
			this.loading = true;
			this.$api
				.faceybdel({ id: this.userInfo.Id })
				.then((res) => {
					this.loading = false;
					this.userInfo.Face = false;
					this.$store.commit('setuserInfo', this.userInfo);
				})
				.catch((err) => {
					this.loading = false;
					this.$store.commit('setsnack', { message: '删除人脸样本失败！' });
					console.error(err);
				});
		},
		startvideo() {
			this.tracker.on('track', this.handleTracked, { camera: true });
		},
		endvideo() {
			this.tracker && this.tracker.removeListener('track', this.handleTracked); // && tracking.track('#facevideo', this.tracker, { camera: false });
		},
		handleTracked(event) {
			if (!event.data || event.data.length == 0) {
				return;
			}
			let _this = this;
			event.data.forEach(function(rect) {
				_this.facetxt = '正在识别...';
				_this.photograph(rect);
			});
		},
		// 拍照
		photograph(rect) {
			let x = rect.x,
				y = rect.y,
				w = rect.width,
				h = rect.height,
				old = this.oldrect;
			if (x == old.x && y == old.y && w == old.width && h == old.height) {
				return;
			}
			this.faceaddnum++;
			if (this.faceaddnum > 5) {
				this.endvideo();
				return;
			}
			this.oldrect = rect;
			this.loading = true;
			if (this.faceWidth != this.videoWidth) {
				let rate = this.videoWidth / this.faceWidth;
				x = parseInt(x * rate);
				y = parseInt(y * rate);
				w = parseInt(w * rate);
				h = parseInt(h * rate);
			}

			let dw = w,
				dh = h,
				dsize = 100;
			if (dw > dsize) {
				dw = dsize;
				dh = parseInt((dsize * rect.height) / rect.width);
			}

			let canvas = this.$refs['canvas'];
			canvas.width = dw;
			canvas.height = dh;
			let ctx = canvas.getContext('2d');
			ctx.drawImage(this.$refs['video'], x, y, w, h, 0, 0, dw, dh);
			let imgBase64 = canvas.toDataURL('image/jpeg', 0.7); // 转base64格式、图片格式转换、图片质量压缩
			let str = imgBase64.replace('data:image/jpeg;base64,', '');
			// console.log("图片大小：",str.length);
			this.$api
				.faceybadd({ img: str, face: this.userInfo.Face })
				.then((res) => {
					if (this.dialog) {
						this.loading = false;
						this.dialog = false;
						this.userInfo.Face = true;
						this.$store.commit('setuserInfo', this.userInfo);
					}
				})
				.catch((err) => {
					if (this.dialog) {
						this.loading = false;
						this.$store.commit('setsnack', { message: '添加人脸数据失败！' });
					}
					console.error(err);
				});
		},
		initdata() {
			this.filesyyzz = [];
			// this.filessfz1 = []
			// this.filessfz2 = []
			this.userInfo = {
				Id: (this.userData && this.userData.Id) || null,
				Username: (this.userData && this.userData.Username) || null,
				Email: (this.userData && this.userData.Email) || null,
				Status: (this.userData && this.userData.Status) || false,
				Face: (this.userData && this.userData.Face) || false,
				Usersproer: {
					Id: (this.userData && this.userData.Usersproer && this.userData.Usersproer.Id) || null,
					Addr: (this.userData && this.userData.Usersproer && this.userData.Usersproer.Addr) || null,
					Code: (this.userData && this.userData.Usersproer && this.userData.Usersproer.Code) || null,
					Faren: (this.userData && this.userData.Usersproer && this.userData.Usersproer.Faren) || null,
					Imgyyzz: (this.userData && this.userData.Usersproer && this.userData.Usersproer.Imgyyzz) || null,
					Name: (this.userData && this.userData.Usersproer && this.userData.Usersproer.Name) || null,
					Openid: (this.userData && this.userData.Usersproer && this.userData.Usersproer.Openid) || null,
					Phone: (this.userData && this.userData.Usersproer && this.userData.Usersproer.Phone) || null,
					Usertype: (this.userData && this.userData.Usersproer && this.userData.Usersproer.Usertype) || 0,
					// Imgsfz1: (this.userData && this.userData.Usersproer && this.userData.Usersproer.Imgsfz1) || null,
					// Imgsfz2: (this.userData && this.userData.Usersproer && this.userData.Usersproer.Imgsfz2) || null,
					Zjnum: (this.userData && this.userData.Usersproer && this.userData.Usersproer.Zjnum) || null,
					Zjaddr: (this.userData && this.userData.Usersproer && this.userData.Usersproer.Zjaddr) || null,
					Zjorg: (this.userData && this.userData.Usersproer && this.userData.Usersproer.Zjorg) || null,
					Zjtype: (this.userData && this.userData.Usersproer && this.userData.Usersproer.Zjtype) || ' ',
					Zjtimestart: (this.userData && this.userData.Usersproer && this.userData.Usersproer.Zjtimestart) || '1970-01-01 00:00:00',
					Zjtimeend: (this.userData && this.userData.Usersproer && this.userData.Usersproer.Zjtimeend) || '1970-01-01 00:00:00',
					Zjgender: (this.userData && this.userData.Usersproer && this.userData.Usersproer.Zjgender) || null,
					Zjpic: (this.userData && this.userData.Usersproer && this.userData.Usersproer.Zjpic) || null,
					Zjnation: (this.userData && this.userData.Usersproer && this.userData.Usersproer.Zjnation) || null,
					Zjname: (this.userData && this.userData.Usersproer && this.userData.Usersproer.Zjname) || null,
				},
			};
			this.oldroles = [];
			if (this.model == 'superadmin-edit') {
				this.userData &&
					this.userData.Rolesp &&
					this.userData.Rolesp.forEach((element) => {
						this.oldroles.push(element.Id);
					});
				this.newroles = [...this.oldroles];
			} else if (this.model == 'superadmin-add') {
				this.newroles = [2];
				this.password = '123456';
				this.configpass = this.password;
			} else {
				this.newroles = [...this.oldroles];
			}
		},
		removeroles(item) {
			const index = this.newroles.indexOf(item.Id);
			if (index >= 0) this.newroles.splice(index, 1);
		},
		delimg(url, item) {
			this.userInfo.Usersproer[item] = '';
			this.$api.delFile({ file: url }).catch((error) => {
				this.$store.commit('setsnack', {
					message: '服务端文件删除失败' + url,
				});
				console.error(error);
			});
		},
		typechange() {
			this.fenlan = this.fenlan == 6 ? 12 : 6;
		},
		submit(val) {
			if (val) {
				if (!this.$refs.userForm.validate() || this.loading) return;
				if (this.model == 'superadmin-add' || this.model == 'superadmin-edit') {
					this.userInfo.Add = this.newroles.filter((v) => !this.oldroles.includes(v));
					this.userInfo.Del = this.oldroles.filter((v) => !this.newroles.includes(v));
					this.userInfo.Add.length > 0 && (this.userInfo.Add = this.userInfo.Add.toString().split(','));
					this.userInfo.Del.length > 0 && (this.userInfo.Del = this.userInfo.Del.toString().split(','));
					this.userInfo.Rolesp = [];
					this.newroles.forEach((item) => {
						let roles = this.roles.filter((v) => v.Id == item);
						if (roles.length > 0) {
							this.userInfo.Rolesp.push(roles[0]);
						}
					});
				}
				if (this.password != null && this.password != '') {
					if (this.model == 'reg') {
						this.userInfo.Password = this.password;
					} else {
						this.userInfo.OldPassword = this.password;
						this.userInfo.NewPassword = this.password;
					}
				}
				this.$emit('submit', this.userInfo);
			} else {
				this.$emit('submit', false);
			}
		},
		viewImg(src) {
			this.$store.commit('setviewimg', this.$store.state.serverhosts + src);
		},
		msg(item, color = 'error') {
			let message = color == 'error' ? '上传失败' : color == 'blue' ? '上传中...' : '上传成功';
			switch (item) {
				case 'Imgyyzz':
					message = '营业执照' + message;
					break;
				// case "Imgsfz1":
				//   message = "身份证正面" + message;
				//   break;
				// case "Imgsfz2":
				//   message = "身份证背面" + message;
				//   break;
				default:
					message = item;
			}
			this.$store.commit('setsnack', { message, color });
		},
		upimg(value, item) {
			if (typeof value === 'undefined') return;
			this.msg(item, 'primary');
			this.loading = true;
			let file = new FormData();
			file.append('file', value);
			this.$api
				.upImg(file)
				.then((res) => {
					this.loading = false;
					this.userInfo.Usersproer[item] = res.data.imgUrl;
					this.msg(item, 'success');
				})
				.catch((error) => {
					console.error(error);
					this.loading = false;
					this.msg(item);
				});
		},
	},
};
</script>
